import React from 'react'
import { StudioRoute, useDeleteRoute } from '@/lib/react-query'
import {
  getRouteRuntimeLabel,
  getRouteTypeLabel,
  useOpenRoute,
  useSetActive,
} from '@/app/routes/Dashboard/Dashboard.hooks'
import { Cell, Row as TableRow } from '@/components/ui/Table'
import { formatDate } from '@/utils/string'
import Switch from '@/components/ui/Switch'
import ConfirmTooltip from '@/components/ConfirmTooltip'
import DeleteButton from '@/components/ui/Buttons/DeleteButton'
import { RouteType, Runtime } from '@/config/app'

export type RouteItemProps = {
  projectId: number
  route: StudioRoute
}

const RouteItem = ({ route, projectId }: RouteItemProps) => {
  const toggleActive = useSetActive(route, projectId)
  const deleteRoute = useDeleteRoute(projectId, route.id!)
  const openRoute = useOpenRoute(route.id!, projectId)
  const runtime = getRouteRuntimeLabel(route.runtime as Runtime)
  const type = getRouteTypeLabel(route.type as RouteType)

  return (
    <TableRow key={route.id} onClick={openRoute}>
      <Cell size={3}>{route.name}</Cell>

      <Cell>{runtime}</Cell>
      <Cell>{type}</Cell>
      <Cell>{formatDate(route.createdAt)}</Cell>
      <Cell>{formatDate(route.updatedAt)}</Cell>
      <Cell size={'80px'} isCentered>
        <Switch checked={route.active} color={route.active ? 'success' : 'neutral'} onClick={toggleActive} />
      </Cell>
      <Cell size={'80px'} isCentered>
        <ConfirmTooltip>
          <DeleteButton onClick={() => deleteRoute.mutate()} isLoading={deleteRoute.isPending} />
        </ConfirmTooltip>
      </Cell>
    </TableRow>
  )
}

export default RouteItem
